import styles from './style.module.scss';
import getFormatMessage from '../../locales/get-format-message';
import rightIcon from '../../assets/svg/right-icon.svg';
import documentRightIcon from '../../assets/svg/document-right.svg';
import classNames from 'classnames';
import { getConfig } from '../../config';
import { getLocaleLanguage, LanguageType } from '../../lib';

export const ProductsHelpGuides = () => {
  const consoleURL = getConfig()?.consoleURL;
  const userURL = getConfig()?.userURL;
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;

  const docNav = [
    {
      itemTitle: getFormatMessage('products_more_details'),
      itemDesc: getFormatMessage('products_more_details_desc'),
      itemUrl:
        currentStoreLanguage === LanguageType.zh_CN
          ? '/doc/detail/36/1006'
          : '/doc/detail/35/1103',
      isDoc: true,
    },
    {
      itemTitle: getFormatMessage('products_more_try_now'),
      itemDesc: getFormatMessage('products_more_try_now_desc'),
      itemUrl: '/email-login',
      isDoc: false,
    },
    {
      itemTitle: getFormatMessage('products_more_contact_us'),
      itemDesc: getFormatMessage('products_more_contact_us_desc'),
      itemUrl: '/contact',
      isDoc: false,
    },
  ];

  const handleDocumentationClick = (docUrl: string, isDoc: boolean) => {
    if (isDoc) {
      if (consoleURL && docUrl) {
        const url = `${consoleURL}${docUrl}`;
        window.open(url, '_blank');
      }
    } else {
      if (userURL && docUrl) {
        location.href = `${userURL}${docUrl}`;
      }
    }
  };

  return (
    <div className={styles.productsHelpGuidesContentBox}>
      {docNav.map((item, index) => {
        return (
          <div
            className={classNames(
              styles.productsHelpGuidesItem,
              styles[`productsHelpGuidesItem${index}`],
              index !== 0 ? styles.productsHelpGuidesItemBorder : ''
            )}
            onClick={() => handleDocumentationClick(item.itemUrl, item.isDoc)}
          >
            <div className={styles.helpGuidesItemTitle}>
              <span>{item.itemTitle || ''}</span>
              <img src={rightIcon} className={styles.helpGuidesItemTitleIcon} />
              <img src={documentRightIcon} className={styles.helpGuidesItemTitleIconMobile} />
            </div>
            <div className={styles.helpGuidesItemDesc}>
              {item.itemDesc || ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};
